import {fetchAndDeserialize} from '../../util/api-adapter';

import {GptLicensesListResponseType, gptLicensesResponseSchema} from './neural-network-type';

const GPT_URL = '/v4/reviews/gpt_suggestions/licence/';

export async function fetchGptLicenses(): Promise<GptLicensesListResponseType> {
    return fetchAndDeserialize(GPT_URL, gptLicensesResponseSchema);
}
